var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaieco(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 72.543,
    viewBox: "0 0 80 72.543",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10893",
    "data-name": "Group 10893",
    transform: "translate(-164 -36)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(89.494 10.837)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M130.366,74.519h-7.819l.828,1.469h6.155l22.4,37.879h-37.1V95.593l8.99-5.9-9.242-6.026-9.39,6.026,9.175,5.936v18.233H77.079l22.4-37.879h6.155l.828-1.469H98.646l-24.14,40.816h80Z",
    transform: "translate(0 -36.439)",
    fill: "#0087c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M162.828,53.07V71.833H179.28l-26.295-46.67-26.3,46.67h16.47V53.07l9.907-6.335Z",
    transform: "translate(-38.479)",
    fill: "#0087c3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(74.596 83.575)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M76.5,248.019h.257q.808,0,1.8,1.222.03,0,3.459,3.449,4.376-4.435,4.445-4.444a1.953,1.953,0,0,1,.818-.227h.246a1.725,1.725,0,0,1,1.5,1.055,1.569,1.569,0,0,1,.108.5v11.047a1.638,1.638,0,0,1-1.015,1.389,1.231,1.231,0,0,1-.532.138H87.2a1.64,1.64,0,0,1-1.35-.867,1.9,1.9,0,0,1-.256-1.1v-6.071q-2.494,2.5-2.533,2.5a1.8,1.8,0,0,1-1.064.335,2.777,2.777,0,0,1-1.971-1.252q-1.6-1.616-1.626-1.616V260.4a1.711,1.711,0,0,1-1.38,1.724.394.394,0,0,1-.2.03h-.394a1.662,1.662,0,0,1-1.409-.975,1.528,1.528,0,0,1-.168-.67v-10.87a1.724,1.724,0,0,1,1.242-1.557A1.921,1.921,0,0,1,76.5,248.019Z",
    transform: "translate(-74.847 -248.019)",
    fill: "#0087c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M140.034,248.019h.305q1.094,0,1.764,1.744,5.056,9.963,5.2,10.357v.532q0,.9-1.183,1.439a1.951,1.951,0,0,1-.414.059h-.256q-1.1,0-1.784-1.8-3.479-6.879-3.528-6.918-3.893,7.825-4.11,8.14a1.707,1.707,0,0,1-1.2.581h-.246a1.7,1.7,0,0,1-1.478-1.084,1.968,1.968,0,0,1-.089-.5v-.217a8.552,8.552,0,0,1,1.005-2.277l4.75-9.382A1.629,1.629,0,0,1,140.034,248.019Z",
    transform: "translate(-117.77 -248.019)",
    fill: "#0087c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M192.893,248.019h.266a1.748,1.748,0,0,1,1.508,1.005,1.684,1.684,0,0,1,.167.778v10.653a1.758,1.758,0,0,1-1.36,1.665,1.435,1.435,0,0,1-.256.03h-.4a1.717,1.717,0,0,1-1.508-1.084,1.337,1.337,0,0,1-.118-.5v-10.9a1.7,1.7,0,0,1,1.3-1.587A1.529,1.529,0,0,1,192.893,248.019Z",
    transform: "translate(-160.686 -248.019)",
    fill: "#0087c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M210.482,248.019h11.028a1.65,1.65,0,0,1,1.606,1.557v.394a1.655,1.655,0,0,1-1.065,1.419,1.744,1.744,0,0,1-.65.138h-9.027v1.8h6.977a1.77,1.77,0,0,1,1.794,1.054,1.38,1.38,0,0,1,.138.562v.246a1.7,1.7,0,0,1-1.261,1.587,1.429,1.429,0,0,1-.394.059h-7.253v1.8h8.83a1.778,1.778,0,0,1,1.912,1.508v.473a1.637,1.637,0,0,1-1.015,1.389,1.229,1.229,0,0,1-.532.138H210.4a1.682,1.682,0,0,1-1.468-1.084,1.439,1.439,0,0,1-.108-.5v-10.9a1.694,1.694,0,0,1,1.261-1.587A1.5,1.5,0,0,1,210.482,248.019Z",
    transform: "translate(-173.708 -248.019)",
    fill: "#0087c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M274.033,248.019h5.647a1.651,1.651,0,0,1,1.607,1.557v.394a1.656,1.656,0,0,1-1.065,1.419,1.747,1.747,0,0,1-.651.138h-4.749a4.244,4.244,0,0,0-4.06,2.365,3.949,3.949,0,0,0-.217,1.251,3.474,3.474,0,0,0,2.188,3.085,4.72,4.72,0,0,0,1.863.414H279.4a1.815,1.815,0,0,1,1.852,1.311l.03.276v.394a1.637,1.637,0,0,1-1.015,1.389,1.229,1.229,0,0,1-.532.138h-5.883a7.092,7.092,0,0,1-4.553-1.863,6.9,6.9,0,0,1-1.547-2.03,6.443,6.443,0,0,1-.759-2.9v-.522a6.864,6.864,0,0,1,2.109-4.76A7.194,7.194,0,0,1,274.033,248.019Z",
    transform: "translate(-216.632 -248.019)",
    fill: "#0087c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M330.085,248.019h4.405a5.841,5.841,0,0,1,4.208,1.7,2.912,2.912,0,0,1,.759,1.7v7.351a3.144,3.144,0,0,1-1.38,2.247,6.446,6.446,0,0,1-3.676,1.143h-4.129a6.033,6.033,0,0,1-4.09-1.468,2.948,2.948,0,0,1-1.015-2.06v-7.076q0-1.745,2.385-2.976A6.926,6.926,0,0,1,330.085,248.019Zm-1.488,3.5v7.135h7.431v-7.135Z",
    transform: "translate(-259.555 -248.019)",
    fill: "#0087c3"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaieco);
export default __webpack_public_path__ + "static/media/maieco.69b414f999abdd41e5519e61b4d0b7bb.svg";
export { ForwardRef as ReactComponent };